import { TAlert } from "~/types/alerts";
import { baseService } from "../base";
import { GetAlertParams, PaginationResponse } from "./alert.type";

export const alertServices = {
  getAlerts: async (params?: GetAlertParams) => {
    const { data } = await baseService.get<PaginationResponse<TAlert>>(
      "/alerts",
      { params }
    );
    return data;
  },
  dismissAlert: async (alertId: string) => {
    const { data } = await baseService.patch<TAlert>(`/alerts/${alertId}/dismiss`);
    return data;
  },
  regenerateAlerts: async () => {
    const { data } = await baseService.patch<{ updated: number }>("/alerts/regenerate");
    return data;
  },
};
